import React from 'react';
import {Form, Textarea, Edit, Suggestions, Flex, List} from 'components';
import {useNamedSelector} from 'helpers';

export function LivingYourValues() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'living-your-values' })}>
      <List tiny-gutter>
        <List.Title>In which parts of your life is your behavior consistent with your values?</List.Title>
        <Flex even stack>
          <Edit name="1" />
          <Edit name="2" />
          <Edit name="3" />
        </Flex>
        <List.Title>Where in your life does your behavior clash with your values?</List.Title>
        <Flex even stack>
          <Edit name="4" />
          <Edit name="5" />
          <Edit name="6" />
        </Flex>
        <List.Title>When is it difficult to make decisions that are aligned with your values?</List.Title>
        <Flex even stack>
          <Edit name="7" />
          <Edit name="8" />
          <Edit name="9" />
        </Flex>
        <List.Title>In which aspects of your work/job are you true to your values?</List.Title>
        <Flex even stack>
          <Edit name="10" />
          <Edit name="11" />
          <Edit name="12" />
        </Flex>
        <List.Title>Where in your work/job do you ignore your values?</List.Title>
        <Flex even stack>
          <Edit name="13" />
          <Edit name="14" />
          <Edit name="15" />
        </Flex>
        <List.Title>How do your core values guide your relationships?</List.Title>
        <Textarea single name="16" />
        <List.Title>Are there any specific behaviors you could change to live in greater harmony with your values?</List.Title>
        <Edit name="17" Suggestions={Suggestions.Behaviors} />
        <Edit name="18" Suggestions={Suggestions.Behaviors} />
        <Edit name="19" Suggestions={Suggestions.Behaviors} />
      </List>
    </Form>
  );
}
